'use es6';

import PurposeOptions from '../constants/CustomModulePurposeOptions';
export default Object.keys(PurposeOptions).filter(function (tagKey) {
  return tagKey !== PurposeOptions.NONE;
});